<template>
    <div id="emptyComponent">
		<h3>Coming soon...</h3>
	</div>
</template>

<script>
    export default {
        name: "Empty"
    }
</script>

<style scoped>

</style>
